import { Spin, type SpinProps } from "antd";
import clsx from "clsx";
import "./BSpin.scss";

const BSpin = ({ className, ...props }: SpinProps) => (
  <Spin className={clsx("b-spin", className)} {...props} />
);

export default BSpin;
